import i18n from 'i18next'

export const NO_CURRENCY_SYMBOL = 'XXX'
const NO_CURRENCY_REGEX = new RegExp(`\\s*${NO_CURRENCY_SYMBOL}\\s*`)

export default class NumberConverter {
  private readonly value: number

  constructor(value: number) {
    this.value = value
  }

  public toLocalizedString(
    options: Intl.NumberFormatOptions = {},
    locales: string | string[] = i18n.language,
  ) {
    return Intl.NumberFormat(locales, options).format(this.value)
  }

  public toLocalizedCurrencyString(
    currency: string = NO_CURRENCY_SYMBOL,
    options: Intl.NumberFormatOptions = {},
    locales: string | string[] = i18n.language,
  ) {
    const localizedString = this.toLocalizedString(
      { ...options, style: 'currency', currency },
      locales,
    )
    return currency === NO_CURRENCY_SYMBOL
      ? localizedString.replace(NO_CURRENCY_REGEX, '')
      : localizedString
  }

  public toLocalizedPercentString(
    options: Intl.NumberFormatOptions = {},
    locales: string | string[] = i18n.language,
  ) {
    return this.toLocalizedString({ ...options, style: 'percent' }, locales)
  }
}
